import { gql } from '@apollo/client';
import client from 'graphql/client';

export const AD_DISCOUNT_LIST_QUERY = gql(`
  query adDiscountList {
    adDiscountList {
      adType
      minimumAdCount
      discountPercentage
    }
  }
`);

const fetchAdDiscountListGraphql = () => {
  return client.query({
    query: AD_DISCOUNT_LIST_QUERY,
  });
};

export default fetchAdDiscountListGraphql;
